export const userRightsInitialState = {
  error: {},
  data: [],
  modulesData: [],
  moduleError: {},
  permissions: [],
  loading: false,
};
